import React, { useId } from 'react';

/**
 * Jaipur visual language: block-print motifs and hand-drawn marks.
 * All shapes use currentColor, so set colour with a text-* class (works in dark mode).
 */

/** Repeating block-print pattern (buta flower in a lattice) for section backgrounds. */
export function BlockPrintPattern({ className = '', opacity = 0.08, size = 56 }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg aria-hidden="true" className={`pointer-events-none absolute inset-0 h-full w-full ${className}`} style={{ opacity }}>
      <defs>
        <pattern id={`bp-${id}`} width={size} height={size} patternUnits="userSpaceOnUse">
          <g fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
            <path d={`M${size / 2} 8 C ${size / 2 + 8} 16, ${size / 2 + 8} 26, ${size / 2} 32 C ${size / 2 - 8} 26, ${size / 2 - 8} 16, ${size / 2} 8 Z`} />
            <path d={`M${size / 2} 32 V ${size - 10}`} />
            <path d={`M${size / 2} 40 q 7 -2 10 -8 M${size / 2} 44 q -7 -2 -10 -8`} />
            <circle cx="0" cy="0" r="2.2" fill="currentColor" stroke="none" />
            <circle cx={size} cy="0" r="2.2" fill="currentColor" stroke="none" />
            <circle cx="0" cy={size} r="2.2" fill="currentColor" stroke="none" />
            <circle cx={size} cy={size} r="2.2" fill="currentColor" stroke="none" />
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#bp-${id})`} />
    </svg>
  );
}

/** Scalloped jharokha arch edge, for section dividers. */
export function ArchDivider({ className = '' }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 1200 24" preserveAspectRatio="none" className={`block h-4 w-full sm:h-6 ${className}`}>
      <path
        fill="currentColor"
        d={Array.from({ length: 24 })
          .map((_, i) => `M${i * 50} 24 Q ${i * 50 + 25} -8 ${i * 50 + 50} 24`)
          .join(' ')}
      />
    </svg>
  );
}

/** Hand-drawn underline to mark a key word. Place inside a relative inline-block span. */
export function Squiggle({ className = '' }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 220 18" preserveAspectRatio="none" className={`absolute -bottom-2 left-0 h-3 w-full sm:h-4 ${className}`}>
      <path d="M3 12 C 40 3, 70 16, 110 8 S 180 4, 217 10" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

/** Small hand-drawn sparkle / star sticker. */
export function Sparkle({ className = '' }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 40 40" className={className}>
      <path d="M20 3 C 21 14, 26 19, 37 20 C 26 21, 21 26, 20 37 C 19 26, 14 21, 3 20 C 14 19, 19 14, 20 3 Z" fill="currentColor" />
    </svg>
  );
}
